module.exports = __webpack_public_path__ + "img/img_box2.05ffe607.png";